module.exports = __webpack_public_path__ + "img/gardens.c4a7c95e.jpg";